<template>
<div class="campaigns-item">

  <!-- Desktop -->
  <div class="hidden-xs campaign-item-desktop">
    <div class="item flex-2 center-left">
      {{ campaign.name }}
    </div>
    <div class="item flex-2 center-right">
      {{ statusLabel }}
      <i class="fa fa-circle fa-fw" aria-hidden="true" :class="statusClass"></i>
    </div>
    <div class="item flex-2 text-right">
      {{ durationLabel }}<br>
      ({{ durationHuman }})
    </div>
    <div class="item center-right">
      {{ campaign.cars }}
    </div>
    <div class="item center-right">
      {{ campaign.impressions['In zone'].toLocaleString(lang) }}
    </div>
    <div class="item center-right">
      {{ createdDate.toLocaleDateString(lang) }}
    </div>
    <div class="item flex-2 center-right">
      <div class="progress">
        <div class="progress-bar" :style="{width:progress+'%'}"></div>
      </div>
      
    </div>
    <div class="item center-right" @click="dropdown" v-if='!menu'>
      <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
    </div>
    <div class="item" v-if='menu' @mouseleave='hide'>
      <ul class="dropdown">
        <li>
          <router-link :to="{ name: 'Campaign', params: {campaignID: campaign.id} }" tag="a">
            {{ $t('campaigns.menu.details') }}
          </router-link>
        </li>
      </ul>
    </div>
  </div>

  <!-- Mobile -->
  <div class="visible-xs-block campaign-item-mobile">
    <h4 class="text-center">
        {{ campaign.name }}
        <span class="pull-right" @click="dropdown"><i class="fa fa-ellipsis-v" aria-hidden="true"></i></span>
        <ul class="dropdown" v-if='menu' @mouseleave='hide'>
            <li>
              <router-link :to="{ name: 'Campaign', params: {campaignID: campaign.id} }" tag="a">
                {{ $t('campaigns.menu.details') }}
              </router-link>
          </li>
        </ul>
      </h4>
    <div class="row">
      <div class="col-xs-4 text-right bold">
        {{ $t('campaigns.status') }}:
      </div>
      <div class="col-xs-8">
        <i class="fa fa-circle fa-fw" aria-hidden="true" :class="statusClass"></i> {{ statusLabel }}
      </div>
    </div>
    <div class="row">
      <div class="col-xs-4 text-right bold">
        {{ $t('campaigns.duration') }}:
      </div>
      <div class="col-xs-8">
        {{ durationLabel }}<br>({{ durationHuman }})
      </div>
    </div>

    <!-- Vehicles -->
    <div class="row">
      <div class="col-xs-4 text-right bold">
        {{ $t('campaigns.vehicles') }}:
      </div>
      <div class="col-xs-8">
        {{ campaign.cars }}
      </div>
    </div>

    <!-- Impressions -->
    <div class="row">
      <div class="col-xs-4 text-right bold">
        {{ $t('campaigns.impressions') }}:
      </div>
      <div class="col-xs-8">
        {{ campaign.impressions['In zone'].toLocaleString(lang) }}
      </div>
    </div>

    <!-- Created -->
    <div class="row">
      <div class="col-xs-4 text-right bold">
        {{ $t('campaigns.created') }}:
      </div>
      <div class="col-xs-8">
        {{ createdDate.toLocaleDateString(lang) }}
      </div>
    </div>

    <!-- Progress -->
    <div class="row">
      <div class="col-xs-4 text-right bold">
        {{ $t('campaigns.progress') }}:
      </div>
      <div class="col-xs-8 center-right">
        {{ progress }}%
      </div>
    </div>

    <div class="progress">
      <div class="progress-bar" :style="{width:progress+'%'}"></div>
    </div>

  </div>
</div>
</template>

<script>
import moment from 'moment'
import 'moment/locale/en-gb'
import 'moment/locale/de'

import {
  mapState
} from 'vuex'

export default {
  props: ['campaign'],
  data: function () {
    return {
      menu: false
    }
  },
  computed: {
    impressions () {
      return 0
    },
    statusLabel () {
      return this.$t(`campaigns.statuses.${this.campaign.status}`)
    },
    statusClass () {
      return ['fa-grey',
        'fa-orange',
        'fa-green',
        'fa-blue'
      ][this.campaign.status]
    },
    durationLabel () {
      var start = new Date(this.campaign.start)
      var end = new Date(this.campaign.end)
      var options = {
        timeZone: 'Europe/Vienna'
      }
      return start.toLocaleDateString(this.lang, options) + ' - ' + end.toLocaleDateString(this.lang, options)
    },
    durationHuman () {
      moment.locale(this.lang)

      var start = new Date(this.campaign.start)
      var end = new Date(this.campaign.end)
      var diff = moment(start).from(moment(end).add(1, 'days'), true)
      return diff
    },
    createdDate () {
      var created = new Date(this.campaign.created)
      return created
    },
    progress () {
      var self = this
      var c = self.campaign
      if (c.status < 2) {
        return 0
      } else if (c.status === 3) {
        return 100
      } else {
        var duration = moment(c.end).diff(moment(c.start), 'days')
        var span = moment().diff(moment(self.campaign.start), 'days')
        if (span < duration) {
          return Math.floor(span / duration * 100)
        } else {
          return 100
        }
      }
    },
    ...mapState(['lang'])
  },
  methods: {
    dropdown () {
      this.menu = !this.menu
    },
    hide () {
      this.menu = false
    }
  }
}
</script>
<style scoped lang="stylus" src="../styles/_CampaignItem.styl"/>



// WEBPACK FOOTER //
// src/components/CampaignItem.vue